// components/Gallery.js (New component)
import React, { useState } from 'react';
import './Gallery.css';
import { images } from '../utils/images';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <h2 className="section-title">Our Work in Action</h2>
        <p className="section-subtitle">Glimpses of our impact across communities</p>
        <div className="gallery-grid">
          {images.gallery.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image} alt={`Gallery ${index + 1}`} />
              <div className="gallery-overlay">
                <span>View</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Enlarged view" />
          <button className="close-btn">×</button>
        </div>
      )}
    </section>
  );
};

export default Gallery;